var _circle, _circle2, _circle3, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBehanceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_linear_917_16)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "#121212"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "white",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0469 8.86059H18.0566V10.116H23.0469V8.86059ZM20.5859 13.1737C20 13.1737 19.5247 13.3509 19.1602 13.7052C18.7956 14.0596 18.5938 14.5405 18.5547 15.148H22.5391C22.4219 13.8318 21.7708 13.1737 20.5859 13.1737ZM20.7422 19.0966C21.1523 19.0966 21.5495 18.9886 21.9336 18.7726C22.3177 18.5566 22.5651 18.263 22.6758 17.8917H24.834C24.1829 19.9639 22.793 21 20.6641 21C19.2708 21 18.1624 20.5545 17.3389 19.6636C16.5153 18.7726 16.1035 17.6015 16.1035 16.1503C16.1035 14.7464 16.5283 13.5803 17.3779 12.6523C18.2275 11.7242 19.3229 11.2601 20.6641 11.2601C21.5625 11.2601 22.3454 11.4896 23.0127 11.9486C23.68 12.4076 24.1781 13.0117 24.5068 13.7609C24.8356 14.5101 25 15.3471 25 16.2718C25 16.3866 24.9935 16.5452 24.9805 16.7477H18.5547C18.5547 17.4969 18.7419 18.0757 19.1162 18.484C19.4906 18.8924 20.0326 19.0966 20.7422 19.0966ZM7.70508 18.5903H10.5957C11.9303 18.5903 12.5977 18.0267 12.5977 16.8995C12.5977 15.6846 11.9499 15.0771 10.6543 15.0771H7.70508V18.5903ZM7.70508 13.1534H10.4492C10.957 13.1534 11.359 13.0302 11.6553 12.7839C11.9515 12.5375 12.0996 12.1545 12.0996 11.6347C12.0996 10.6628 11.4811 10.1768 10.2441 10.1768H7.70508V13.1534ZM5 8H10.8008C11.3672 8 11.8717 8.04725 12.3145 8.14174C12.7572 8.23624 13.1689 8.39655 13.5498 8.62266C13.9307 8.84878 14.2236 9.17445 14.4287 9.59969C14.6338 10.0249 14.7363 10.5447 14.7363 11.1589C14.7363 12.3806 14.1764 13.2682 13.0566 13.8217C13.7988 14.0376 14.3587 14.4258 14.7363 14.986C15.1139 15.5462 15.3027 16.2347 15.3027 17.0514C15.3027 17.5576 15.223 18.0183 15.0635 18.4334C14.904 18.8485 14.6891 19.1978 14.4189 19.4813C14.1488 19.7648 13.8281 20.0044 13.457 20.2002C13.0859 20.3959 12.6921 20.5376 12.2754 20.6254C11.8587 20.7131 11.4225 20.757 10.9668 20.757H5V8Z",
    fill: "url(#paint1_linear_917_16)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_917_16",
    x1: 14.5,
    y1: -21.5,
    x2: 15,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#AA771C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307292,
    stopColor: "#FBF5B7",
    stopOpacity: 0.286458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#B38728",
    stopOpacity: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#FCF6BA",
    stopOpacity: 0.713542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA771C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_917_16",
    x1: 15,
    y1: -0.45,
    x2: 15,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF953F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCF6BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#B38728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBF5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA771C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehanceIcon);
export default __webpack_public_path__ + "static/media/behanceIcon.0ff6976705bc89e0157c595d4c55fe7f.svg";
export { ForwardRef as ReactComponent };